import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-debug',
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss']
})
export class DebugComponent implements OnInit {

  constructor() {
    localStorage.removeItem('l');
    localStorage.removeItem('points')
    localStorage.removeItem('interactionIds')
    localStorage.removeItem('interacionsCompletedIds')
  }

  ngOnInit(): void {
  }

}
